import React, { useState } from 'react';
import { withRouter } from 'react-router-dom';
import {
  SearchIcon,
  SpacingBox,
  NavMenuModal,
  DebouncedGreyInvertedBigInput,
  Container,
} from '../Components';
import { WithProductsSearchWithInput } from './WithProductsSearch';
import ProductSearchPreview from './ProductSearchPreview';
import { routes } from '../routes';

const TopMenuModal = withRouter(({ setIsOpen, isOpen, history }) => (
  <NavMenuModal onCancel={() => setIsOpen(false)} isOpen={isOpen}>
    <Container>
      <WithProductsSearchWithInput
        defaultSearch=""
        page={1}
        renderInputComponent={({ search, handleSearch }) => (
          <DebouncedGreyInvertedBigInput
            placeholder="Search"
            onChange={handleSearch}
            value={search}
          />
        )}>
        {({ products, search, setSearch }) => (
          <SpacingBox marginTop="md">
            <ProductSearchPreview
              products={products}
              search={search}
              onClick={(name, color) => {
                setSearch('');
                history.push(routes.productDetail({ name, color }));
                setIsOpen(false);
              }}
              onRouteToAllResults={() => setIsOpen(false)}
            />
          </SpacingBox>
        )}
      </WithProductsSearchWithInput>
    </Container>
  </NavMenuModal>
));

const Search = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <TopMenuModal isOpen={isOpen} setIsOpen={setIsOpen} />
      <SearchIcon onClick={() => setIsOpen(true)} size="sm" />
    </>
  );
};

export default Search;
